export default "https://cdn-static.gokick.com/assets/6ff5832d0d355fee068eb0a1603b37a2d61221c6/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";